import invariant from 'invariant';
import * as React from 'react';
import ReactDOM from 'react-dom';
import ToastsContainer from 'components/ToastsContainer';

let toastsContainerRoot: Element;
if (typeof window !== 'undefined') {
  toastsContainerRoot = document.createElement('div');
  window.document.body.appendChild(toastsContainerRoot);
}

type Props = {};

class ToastsContainerNode extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    invariant(
      toastsContainerRoot,
      'toastsContainerRoot missing in ToastsContainerNode componentDidMount'
    );
    invariant(this.el, 'element missing in ToastsContainerNode componentDidMount');
    toastsContainerRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    invariant(
      toastsContainerRoot,
      'toastsContainerRoot missing in ToastsContainerNode componentWillUnmount'
    );
    invariant(this.el, 'element missing in ToastsContainerNode componentWillUnmount');
    toastsContainerRoot.removeChild(this.el);
  }

  el: Element;

  render() {
    invariant(this.el, 'element missing in ToastsContainerNode render');
    return ReactDOM.createPortal(<ToastsContainer />, this.el);
  }
}

export default ToastsContainerNode;
